import axios from "axios";
import moment from "moment";
import * as actionTypes from "./actionTypes";

export const getStravaAuthCodeStart = () => {
  return {
    type: actionTypes.STRAVA_GET_AUTH_CODE,
  };
};

export const getStravaAuthCodeSuccess = (
  firstName,
  lastName,
  profileImage,
  city
) => {
  return {
    type: actionTypes.STRAVA_GET_AUTH_CODE_SUCCESS,
    profileImage: profileImage,
    firstName: firstName,
    lastName: lastName,
    city: city,
  };
};

export const getStravaActivitiesSuccess = (activities) => {
  return {
    type: actionTypes.STRAVA_GET_ACTIVITIES_SUCCESS,
    activities,
  };
};

export const getStravaActivitiesStart = () => {
  return {
    type: actionTypes.STRAVA_GET_ACTIVITIES_START,
  };
};

export const getStravaActivitiesFinish = () => {
  return {
    type: actionTypes.STRAVA_GET_ACTIVITIES_FINISH,
  };
};

export const getStravaAthleteSuccess = (athlete) => {
  return {
    type: actionTypes.STRAVA_GET_ATHLETE,
    athlete,
  };
};

export const getStravaAuthCode = (authCode, refresh_token, tokenExpired) => {
  // alert(tokenExpired);
  const refreshURL = `https://www.strava.com/oauth/token?client_id=${process.env.REACT_APP_STRAVA_CLIENT_ID}&client_secret=${process.env.REACT_APP_STRAVA_CLIENT_SECRECT}&refresh_token=${refresh_token}&grant_type=refresh_token`;
  const url = `https://www.strava.com/oauth/token?client_id=${process.env.REACT_APP_STRAVA_CLIENT_ID}&client_secret=${process.env.REACT_APP_STRAVA_CLIENT_SECRECT}&code=${authCode}&grant_type=authorization_code`;

  return (dispatch) => {
    // debugger;
    dispatch(getStravaAuthCodeStart());
    // debugger;
    if (tokenExpired && refresh_token !== null) {
      console.log("refreshURL", refreshURL);
      axios
        .post(refreshURL)
        .then((response) => {
          const tokenExpirationDate = new Date(
            new Date().getTime() + response.data.expires_in * 1000
          );

          localStorage.setItem("access_token", response.data.access_token);
          localStorage.setItem("expirationDate", tokenExpirationDate);

          dispatch(getStravaAthlete(response.data.access_token));
          // dispatch(getStravaActivities(response.data.access_token));
        })
        .then(() => {
          const access_token = localStorage.getItem("access_token");
          dispatch(getStravaAthlete(access_token));
        })
        .catch((err) => {
          console.log(err);
        });

      return;
    }
    axios
      .post(url)
      .then((response) => {
        const tokenExpirationDate = new Date(
          new Date().getTime() + response.data.expires_in * 1000
        );

        localStorage.setItem("access_token", response.data.access_token);
        localStorage.setItem("refresh_token", response.data.refresh_token);
        localStorage.setItem("athlete_id", response.data.athlete.id);
        localStorage.setItem("expirationDate", tokenExpirationDate);

        dispatch(
          getStravaAuthCodeSuccess(
            response.data.athlete.firstname,
            response.data.athlete.lastname,
            response.data.athlete.profile,
            response.data.athlete.city
          )
        );
        // dispatch(getStravaActivities(response.data.access_token));
      })
      .then(() => {
        const access_token = localStorage.getItem("access_token");
        dispatch(getStravaAthlete(access_token));
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const getStravaAthlete = (access_token) => {
  return (dispatch) => {
    let athleteURL = `https://www.strava.com/api/v3/athlete?access_token=${access_token}`;

    axios.get(athleteURL).then((response) => {
      console.log("athlete", response);
      dispatch(getStravaAthleteSuccess(response.data));
      // dispatch(getStravaActivities(access_token));
    });
  };
};

export const getStravaActivities = (
  access_token,
  start_date,
  end_date,
  minMileage
) => {
  return (dispatch) => {
    debugger;

    dispatch(getStravaActivitiesStart());
    let activitiesURLs = `https://www.strava.com/api/v3/athlete/activities?access_token=${access_token}`;

    axios
      .get(activitiesURLs)
      .then((response) => {
        dispatch(
          getStravaActivitiesSuccess({
            items: response.data
              .filter(
                (activitity) =>
                  moment(activitity.start_date_local) >=
                    moment(start_date.seconds * 1000) &&
                  moment(activitity.start_date_local) <=
                    moment(end_date.seconds * 1000) &&
                  (activitity.distance * 0.001).toFixed(2) > minMileage &&
                  activitity.type === "Run"
              )
              .sort(
                (a, b) =>
                  moment(a.start_date_local) - moment(b.start_date_local)
              ),
          })
        );
      })
      .then(dispatch(getStravaActivitiesFinish()))
      .catch((err) => {
        console.log(err);
      });
  };
};

// export const stravaAuthCheckState = () => {
//   return (dispatch) => {
//     const token = localStorage.getItem("access_token");
//     if (!token) {
//       // dispatch(logout());
//     } else {
//       const expirationDate = new Date(localStorage.getItem("expirationDate"));
//       if (expirationDate <= new Date()) {
//         // dispatch(logout());
//       } else {
//         const userId = localStorage.getItem("userId");
//         dispatch(authSuccess(token, userId));
//         dispatch(
//           checkAuthTimeout(
//             (expirationDate.getTime() - new Date().getTime()) / 1000
//           )
//         );
//       }
//     }
//   };
// };
